<template>
  <div
    class="scroll-container"
    :style="'height: calc(100vh - ' + heightOffset + ');'"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    heightOffset: {
      type: String,
      default: '0',
    },
  },

}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss" scoped>
.scroll-container {
    overflow-y: auto;
}
</style>
